import { post } from 'lib/httpClient';

const create_setup_intent = async (
  callback: ((data: any) => void) | null = null
): Promise<void> => {
  const path = '/payment/create_setup_intent';
  const result = await post(path, null);
  console.debug('create_payment_intent', result);
  if (callback !== null) {
    callback(result?.data);
  } else return result?.data;
};

export { create_setup_intent };
